export const RAPPORT_LH_SCENE_PROJET_DEFAUT = Object.freeze ({
  largeur : 16,
  hauteur : 9,
});

export const RAPPORT_LH_SCENE_PROJET_LIMITES = Object.freeze ({
  largeur : {min : 0.1, max : 1000},
  hauteur : {min : 0.1, max : 1000},
});

export const SCENE_VIGNETTE_LARGEUR_REFERENCE = 768;

function borne_nombre (pValeur, pBornes)
  {
    if (!Number.isFinite (pValeur)) return null;
    return Math.max (pBornes.min, Math.min (pBornes.max, pValeur));
  }

function arrondit_nombre (pValeur)
  {
    return Math.round (pValeur * 1000) / 1000;
  }

function parse_nombre (pValeur)
  {
    if (typeof pValeur === "number") return Number.isFinite (pValeur) ? pValeur : null;
    if (typeof pValeur !== "string") return null;
    const tTexte = pValeur.trim ().replace (/,/g, ".");
    if (!tTexte) return null;
    const tNombre = Number (tTexte);
    return Number.isFinite (tNombre) ? tNombre : null;
  }

function normalise_tuple_rapport (pLargeur, pHauteur)
  {
    const tLargeur = borne_nombre (parse_nombre (pLargeur), RAPPORT_LH_SCENE_PROJET_LIMITES.largeur);
    const tHauteur = borne_nombre (parse_nombre (pHauteur), RAPPORT_LH_SCENE_PROJET_LIMITES.hauteur);
    if (!tLargeur || !tHauteur) return null;
    return {
      largeur : arrondit_nombre (tLargeur),
      hauteur : arrondit_nombre (tHauteur),
    };
  }

export function parse_rapport_lh_scene_projet (pValeur)
  {
    if (!pValeur) return null;

    if (typeof pValeur === "object")
      {
        return normalise_tuple_rapport (
          pValeur.largeur ?? pValeur.width ?? pValeur.w,
          pValeur.hauteur ?? pValeur.height ?? pValeur.h
        );
      }

    if (typeof pValeur === "number")
      return normalise_tuple_rapport (pValeur, 1);

    if (typeof pValeur !== "string") return null;

    const tTexte = pValeur.trim ();
    if (!tTexte) return null;

    const tMatch = tTexte.match (/^([0-9]+(?:[.,][0-9]+)?)\s*(?:\/|:|x|×)\s*([0-9]+(?:[.,][0-9]+)?)$/i);
    if (tMatch)
      return normalise_tuple_rapport (tMatch[1], tMatch[2]);

    return normalise_tuple_rapport (tTexte, 1);
  }

export function normalise_rapport_lh_scene_projet (pValeur)
  {
    return parse_rapport_lh_scene_projet (pValeur)
      || {...RAPPORT_LH_SCENE_PROJET_DEFAUT};
  }

function format_nombre_rapport (pValeur, pLocale = "fr-FR")
  {
    const tValeur = arrondit_nombre (Number (pValeur) || 0);
    if (Number.isInteger (tValeur)) return String (tValeur);
    return tValeur.toLocaleString (
      pLocale,
      {
        useGrouping : false,
        minimumFractionDigits : 0,
        maximumFractionDigits : 3,
      }
    );
  }

export function format_rapport_lh_scene_projet (pValeur, pLocale = "fr-FR")
  {
    const tRapport = normalise_rapport_lh_scene_projet (pValeur);
    return `${format_nombre_rapport (tRapport.largeur, pLocale)}/${format_nombre_rapport (tRapport.hauteur, pLocale)}`;
  }

export function format_css_rapport_lh_scene_projet (pValeur)
  {
    const tRapport = normalise_rapport_lh_scene_projet (pValeur);
    return `${tRapport.largeur} / ${tRapport.hauteur}`;
  }

export function ratio_rapport_lh_scene_projet (pValeur)
  {
    const tRapport = normalise_rapport_lh_scene_projet (pValeur);
    return tRapport.largeur / tRapport.hauteur;
  }

export function dimensions_scene_vignette_pour_rapport (pValeur, pLargeurReference = SCENE_VIGNETTE_LARGEUR_REFERENCE)
  {
    const tLargeur = Math.max (1, Math.round (Number (pLargeurReference) || SCENE_VIGNETTE_LARGEUR_REFERENCE));
    const tRatio = ratio_rapport_lh_scene_projet (pValeur);
    return {
      largeur : tLargeur,
      hauteur : Math.max (1, Math.round (tLargeur / tRatio)),
    };
  }